// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"207":"4272810c72090638","5826":"cbc47f1b60c2355f"}[chunkId] + ".css";
};